import { ExareReason, ExareReasonDocs, RefundInfoFragment, CheckoutOrderFragment } from '@websky/graphql';
import { GdsServicesRefundInfo } from './store/gdsServicesRefundInfo/actions';
import { ErrorState } from '@entities/error';

export enum RefundMode {
	Auto = 'Auto',
	Manual = 'Manual'
}

export interface PassengerIdDocumentMap {
	[key: string]: string;
}

export enum StepType {
	Passengers = 'Passengers',
	Reason = 'Reason',
	AttachFiles = 'AttachFiles',
	CreateTicket = 'CreateTicket',
	Ticket = 'Ticket'
}

export interface Step {
	type: StepType;
	additionalText: string;
	isActive: boolean;
}

export type Steps = Step[];

export enum VoluntaryReason {
	Voluntary = 'Voluntary'
}

export type ReasonType = ExareReason | VoluntaryReason;

export interface Reason {
	title: string;
	checked: boolean;
	value: ReasonType;
	docs: ExareReasonDocs[];
}

export interface ReasonGroup {
	title: string;
	reasons: Reason[];
}

export type Passenger = {
	id: string;
	name: string;
	selected: boolean;
	children?: Children;
	phone?: string;
	email?: string;
};

export type Children = Omit<Passenger, 'children' | 'selected'>[];

export type PassengersState = { [key: string]: Passenger };

export type DocksFilesMap = { [key in ExareReason]: ExareReasonDocs };

export interface Document {
	name: string;
	content: string;
}

export interface DocumentsState {
	[key: string]: Document[];
}

export type RefundReason = {
	docs: ExareReasonDocs[];
	title: ReasonType;
};

export interface Customer {
	name: string;
	phone: string;
	email: string;
	comments: string;
}

export interface RefundState {
	aviaOrder: CheckoutOrderFragment;
	steps: Steps;
	passengers: PassengersState;
	mode: RefundMode;
	reason: RefundReason;
	documents: DocumentsState;
	refundInfo: RefundInfoFragment;
	gdsServicesRefundInfo: GdsServicesRefundInfo;
	customer: Customer;
	orderId: string;
	flightId: string;
	error?: ErrorState;
}
